import request from '@/utils/request';

export async function queryEntityLog(payload) {
  return request(`/iwms-account/account/logger/entityLog/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function page(payload) {
  return request(`/iwms-wms/wms/rfidinterfacelog/page`, {
    method: 'POST',
    body: payload
  })
}


export async function queryEntityStateLog(payload) {
  return request(`/iwms-wms/wms/commons/billStateLog/getByBillUuid?dcUuid=${payload.dcUuid}&billUuid=${payload.billUuid}`, {
    method: 'GET',
  })
}